export default "__VITE_ASSET__Du0o$s9O__"